import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { ImageDropzone } from '@client/components/input/ImageDropzone';
import { AddFieldButton } from '@client/components/listingForm/AddFieldButton';
import { ImageGrid } from '@client/components/listingForm/imageList/ImageGrid';
import { ImageListProvider } from '@client/components/listingForm/imageList/ImageListContext';
import { ImageTile, RemoveImageButton, } from '@client/components/listingForm/imageList/ImageTile';
import { STANDARD_THUMBNAIL_GAP, STANDARD_THUMBNAIL_WIDTH, } from '@client/constants';
import { LISTING_LIMITS } from '@heirloom/common/constants';
export const ListingImageUpload = ({ imageEntries, onAdd, onRemove, onReorder, disabled, }) => (_jsx(ImageListProvider, { list: {
        entries: imageEntries,
        add: onAdd,
        remove: onRemove,
        reorder: onReorder,
        disabled,
    }, children: _jsxs(Box, { children: [imageEntries.length > 0 && (_jsx(ImageGrid, { gap: STANDARD_THUMBNAIL_GAP, mb: 3, children: _jsx(ImageTile, { w: STANDARD_THUMBNAIL_WIDTH, children: _jsx(RemoveImageButton, {}) }) })), _jsx(ImageDropzone, { onAdd: onAdd, maxFiles: LISTING_LIMITS.maxImages, disabled: disabled, trigger: _jsx(AddFieldButton, { children: "Add Images" }) })] }) }));
